import { useSelector } from "react-redux";

import { Box, IconButton, ListSubheader, Menu, MenuItem, Typography, useTheme } from "@mui/material";
import React, { useCallback } from "react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProjectTabLabel from "./ProjectTabLabel";
import { DragDropContext, Droppable, Draggable,resetServerContext } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";
import { reorderTabs } from "../../features/project";
import { Add, Tune, ChevronLeft, ChevronRight } from "@mui/icons-material";
import { openDialog } from "../../features/dialog";

resetServerContext()

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

function AddMenu(){
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleMenuClick = (dialog) => {
        handleClose();
        dispatch(openDialog(dialog));
    }
    return <Box 
        alignItems="center" 
        display="flex" 
        flexDirection="column" 
        sx={{
            mt: 1,
            p: 1,
            pt: 2.5,
            ml: 2.5,
        }}
    >
        <IconButton
            aria-controls={open ? 'add-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
        >
            <Add color="primary" fontSize={"medium"} />
        </IconButton>
        <Menu
            id="add-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
            'aria-labelledby': 'add-button',
            }}
        >
            <ListSubheader title="Create new" sx={{fontWeight: 'bold', fontSize: '100%'}}>Create New</ListSubheader>
            <MenuItem onClick={() => handleMenuClick("editDashboard")}>Dashboard</MenuItem>
            <MenuItem onClick={() => handleMenuClick("newReport")}>Report</MenuItem>
            <MenuItem onClick={() => handleMenuClick("newAlert")}>Alert</MenuItem>
        </Menu>

    </Box>
    
}

function ProjectTabs({ activeTab, project }) {
    const navigate = useNavigate();
    const theme = useTheme();
    const dispatch = useDispatch();
    const [tabs, setTabs] = useState([]);
    const railRef = useRef(null); //scrollable container (Droppable)
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const user = useSelector(state => state.user.profile);

    useEffect(() => {
        let _tabs = [...project.tabs];
        setTabs(_tabs);
    }, [project.tabs])


    // --- overflow state management
    const updateOverflowState = useCallback(() => {
        const el = railRef.current;
        if (!el) return;
        const { scrollLeft, scrollWidth, clientWidth } = el;
        setCanScrollLeft(scrollLeft > 0);
        // setCanScrollRight(scrollWidth - Math.ceil(scrollLeft + clientWidth) > 0);
        setCanScrollRight(scrollWidth - (scrollLeft + clientWidth) > 1);
    }, []);

    useEffect(() => {
        updateOverflowState();
        const el = railRef.current;
        if (!el) return;
        const onScroll = () => updateOverflowState();
        el.addEventListener('scroll', onScroll, { passive: true });
        // ResizeObserver to react to container/label size changes
        const ro = new ResizeObserver(() => updateOverflowState());
        ro.observe(el);
        window.addEventListener('resize', updateOverflowState);
        return () => {
            el.removeEventListener('scroll', onScroll);
            ro.disconnect();
            window.removeEventListener('resize', updateOverflowState);
        };
    }, [updateOverflowState, tabs.length]);

    // Keep active tab in view when activeTab or tabs change
    useEffect(() => {
        const el = railRef.current;
        if (!el) return;
        const activeIdx = tabs.findIndex(t => String(t.id) === String(activeTab));
        if (activeIdx === -1) return;
        const node = el.querySelector(`[data-tab-id="${tabs[activeIdx].id}"]`);
        if (node) {
            const nodeRect = node.getBoundingClientRect();
            const railRect = el.getBoundingClientRect();
            const isFullyVisible = nodeRect.left >= railRect.left && nodeRect.right <= railRect.right;
            if (!isFullyVisible) {
                // center-ish scroll
                const delta = (node.offsetLeft - (el.clientWidth / 2 - node.clientWidth / 2));
                el.scrollTo({ left: Math.max(0, delta), behavior: 'smooth' });
            }
        }
    }, [activeTab, tabs]);

    const scrollByPage = useCallback((dir = 1) => {
        const el = railRef.current;
        if (!el) return;
        const page = Math.max(100, el.clientWidth - 48); // one "page" minus a small gutter
        el.scrollBy({ left: dir * page, behavior: 'smooth' });
    }, []);
    // --- end overflow state management

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            tabs,
            result.source.index,
            result.destination.index
        );
        dispatch(reorderTabs({
            project_id: project.id,
            tabs: items.map(i => i.id)
        }))

        setTabs(items);
    }

    const clickTab = useCallback((tabId) => {
        navigate("/project/" + project.label + "/" + tabId);
    }, [project.label, navigate])

    return <Box display="flex" flexDirection="row" justifyContent="space-between" sx={{
        borderBottom: 1,
        borderBottomColor: 'primary',
        overflow: 'hidden',
    }}>

    <Box display="flex" sx={{ 
        flex: 1,
        minWidth: 0,
        maxWidth:'80vw',
        position: 'relative',
        gap:1,
        overflow: 'hidden',
        }}>


            {/* <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable" direction="horizontal">
                    {(provided, snapshot) => (
                        <Box 
                            display="flex" 
                            flexDirection={"row"}
                            sx = {{ whiteSpace: 'nowrap'}} //hard stop: no wrapping
                            mt={1}
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >

                         */}

                        <DragDropContext onDragEnd={onDragEnd}>
                        {/* SCROLLABLE RAIL */}
                        <Droppable droppableId="droppable" direction="horizontal">
                            {(provided) => (
                            <Box
                                // rail container
                                ref={(node) => {
                                railRef.current = node;
                                provided.innerRef(node);
                                }}
                                {...provided.droppableProps}
                                display="flex"
                                flexDirection="row"
                                mt={1}
                                sx={{
                                flex: 1,
                                minWidth: 0,
                                overflowX: 'auto',
                                overflowY: 'hidden',
                                whiteSpace: 'nowrap',
                                scrollbarWidth: 'thin',        // Firefox
                                '&::-webkit-scrollbar': { height: 8 }, // WebKit
                                '&::-webkit-scrollbar-thumb': { borderRadius: 8 },
                                // ensure children (tabs) don't wrap
                                }}
                            >

                            {tabs.map((tab, index) => (
                                <Draggable key={tab.id} draggableId={tab.id + ""} index={index}>
                                    {(provided, snapshot) => (
                                        // <ProjectTabLabel
                                        <Box
                                            //wrapper ensures we have a marker to find the tab for scrollIntoView
                                            data-tab-id={tab.id}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        //     onClick={() => clickTab(tab.id)}
                                        //     key={tab.id}
                                        //     index={index}
                                        //     id={tab.id}
                                        //     tab={tab}
                                        //     activeTab={activeTab}
                                        // />
                                        sx = {{ display: 'inline-flex'}}
                                        >
                                            <ProjectTabLabel
                                                onClick={() => clickTab(tab.id)}
                                                key={tab.id}
                                                index={index}
                                                id={tab.id}
                                                tab={tab}
                                                activeTab={activeTab}
                                            />
                                        </Box>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </Box>
                    )}
                </Droppable>
            </DragDropContext>
            
            {/* <AddMenu /> */}

            {/* EDGE GRADIENTS (non-interactive) */}
            {canScrollLeft && (
                <Box
                aria-hidden
                sx={{
                    position: 'absolute', left: 0, top: 0, bottom: 0, width: 24, pointerEvents: 'none',
                    background: `linear-gradient(90deg, ${theme.palette.background.default} 0%, ${theme.palette.background.default}00 100%)`,
                    mt: 1
                }}
                />
            )}
            {canScrollRight && (
                <Box
                aria-hidden
                sx={{
                    position: 'absolute', right: 48 /* leave room for chevron */, top: 0, bottom: 0, width: 24, pointerEvents: 'none',
                    background: `linear-gradient(270deg, ${theme.palette.background.default} 0%, ${theme.palette.background.default}00 100%)`,
                    mt: 1
                }}
                />
            )}

            {/* CHEVRONS (outside droppable to avoid DnD interference) */}
            {canScrollLeft && (
                <Box
                    onClick={() => scrollByPage(-1)}
                    sx={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 40,                   // width of the gradient strip
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    cursor: 'pointer',
                    zIndex: 2,
                    background: (theme) =>
                        `linear-gradient(90deg, ${theme.palette.background.default} 0%, transparent 100%)`,
                    }}
                >
                <ChevronLeft />
            </Box>
            )}
            {canScrollRight && (
            <Box
                onClick={() => scrollByPage(1)}
                sx={{
                position: 'absolute',
                right: 0,
                top: 0,
                bottom: 0,
                width: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                cursor: 'pointer',
                zIndex: 2,
                background: (theme) =>
                    `linear-gradient(270deg, ${theme.palette.background.default} 0%, transparent 100%)`,
                }}
            >
                <ChevronRight/>
            </Box>
            )}


        </Box>
            <AddMenu />
      {
        user.tier < 4 ? <>
        {/* hide edit project from base users */}
        <Box 
            // onClick={() => dispatch(openDialog("editProject"))}
            onClick={() => navigate("/project/" + project.label + "/edit")}
            alignItems="center" 
            display="flex" 
            flexDirection="column" 
            sx={{
                bgcolor: 'primary.main',
                mt: 1,
                p: 1,
                cursor: 'pointer'
            }}
        >
            <IconButton><Tune htmlColor={theme.palette.primary.contrastText} fontSize={"medium"} /></IconButton>
            <Typography  
                mt={1} 
                textAlign="center" 
                color={theme.palette.primary.contrastText } 
                textTransform={"uppercase"}
                noWrap
                variant="subtitle2">
                    Edit project
                </Typography>
        </Box>

        </>:<></>
      }
        
    </Box>
}
export default ProjectTabs;